// typescript
import { SubscriptionActions } from 'client/actions/actionTypes'
import { AvailableSubscriptionPlansStateType } from 'client/Interfaces/Subscription/ReduxStateInterfaces'

import { SubscriptionPlanInterface } from '../../Interfaces/Subscription'
import { ReducerBuilder } from '../ReducerBuilder'

type payloadType = SubscriptionPlanInterface[]

const initialState = { loaded: false, collection: [] }

const setPlans = (state: AvailableSubscriptionPlansStateType, payload: SubscriptionPlanInterface[]) => {
  return { loaded: true, collection: payload }
}

const reducer = ReducerBuilder.create<AvailableSubscriptionPlansStateType, payloadType>(initialState)
  .mapAction(SubscriptionActions.LOAD_AVAILABLE_PLANS, setPlans)
  .build()

export default reducer
